import {} from "@redotech/money/currencies"; // for TS2742
import { CreateShippingRateTableInputSchema } from "@redotech/redo-conversion-core-common/redo-in-shipping/shipping-rate-table";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const createShippingMethod = {
  name: "createShippingMethod" as const,
  input: z.object({
    checkoutExperienceId: zExt.objectId(),
    shippingRateTable: CreateShippingRateTableInputSchema,
  }),
  output: z.null(),
};
export type CreateShippingMethodInput = z.infer<
  typeof createShippingMethod.input
>;
